import { FilterMatchMode } from "primereact/api";

export class BienMueble {

    constructor(config = {}) {
        this.model = {
            id: {
                value: null,
                export: false,
                table: false,
            },
            tipo_bien_mueble: {
                value: null,
                export: false,
                table: true,
                header: 'Tipo de bien:',
                required: 'Tipo de Bien es requerido',
                matchMode: FilterMatchMode.CONTAINS,
            },
            valor_bien: {
                value: null,
                export: false,
                table: true,
                sort: false,
                filter: false,
                header: 'VALOR DEL BIEN USD:',
                required: 'Valor del bien es requerido',
            },
        }
    }

    optionLabel = 'nombre';
}
